import { useEffect, useState } from "react";
import { sessionsApi } from "@/lib/api";
import {
  PageHeader,
  DataTable,
  TH,
  TD,
  Badge,
  EmptyState,
} from "@/components/DashboardUI";
import { Gamepad2 } from "lucide-react";

export default function Sessions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    sessionsApi
      .list()
      .then(setItems)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const statutTone = (s) =>
    s === "TERMINEE" ? "success" : s === "EN_COURS" ? "warning" : "neutral";

  return (
    <div className="p-6 md:p-8 space-y-6" data-testid="sessions-page">
      <PageHeader
        chapter="Chapitre pro · Le journal live"
        title="Sessions live"
        subtitle={`${items.length} sessions enregistrées`}
        testId="sessions-header"
      />

      {loading ? (
        <div className="text-parchemin/50 text-sm font-mono uppercase tracking-widest">
          Chargement…
        </div>
      ) : items.length === 0 ? (
        <EmptyState
          icon={<Gamepad2 className="w-6 h-6" />}
          title="Aucune session enregistrée."
          hint="Les parties en cours ou terminées apparaîtront ici."
          testId="sessions-empty"
        />
      ) : (
        <DataTable testId="sessions-table">
          <thead>
            <tr>
              <TH>Groupe</TH>
              <TH>Parcours</TH>
              <TH>Code</TH>
              <TH>Statut</TH>
              <TH align="right">Score</TH>
              <TH align="right">Cadenas</TH>
            </tr>
          </thead>
          <tbody>
            {items.map((s) => (
              <tr
                key={s.id}
                className="border-t border-or/10 hover:bg-noir-100/40 transition"
                data-testid={`session-row-${s.id}`}
              >
                <TD className="font-medium text-parchemin">{s.groupeNom}</TD>
                <TD className="text-parchemin/60">
                  {s.parcours?.nom || "—"}
                </TD>
                <TD>
                  <span className="font-mono text-xs text-or tracking-wider">
                    {s.codeAcces}
                  </span>
                </TD>
                <TD>
                  <Badge tone={statutTone(s.statut)}>{s.statut}</Badge>
                </TD>
                <TD align="right">
                  <span className="font-mono text-parchemin">
                    {s.score || 0}
                  </span>
                </TD>
                <TD align="right">
                  <span className="font-mono text-parchemin">
                    {s._count?.codesOuverts || 0}
                  </span>
                </TD>
              </tr>
            ))}
          </tbody>
        </DataTable>
      )}
    </div>
  );
}
